import { useCallback } from 'react';
import type { ThresholdValue } from '../../lib/filters/threshold';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Threshold panel — single luminance cutoff slider. */
export function ThresholdPanel({ value, onChange }: AdjustmentPanelProps<ThresholdValue>) {
  const set = useCallback(
    (patch: Partial<ThresholdValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );
  return (
    <div className="space-y-3">
      <RangeRow
        label="Threshold"
        min={0}
        max={255}
        step={1}
        value={value.threshold}
        onChange={(v) => set({ threshold: v })}
      />
    </div>
  );
}
